import React from 'react';

import Dialog from '@material-ui/core/Dialog';

import { S } from './styles';

const ConfirmationModal = ({ open, onClose, onSubmit }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 0 },
      }}
    >
      <S.ModalContainer>
        <S.ModalHeader>
          <S.ModalTitle>Confirmar desativação</S.ModalTitle>
          <S.CloseButton name="close" onClick={onClose} />
        </S.ModalHeader>
        <S.ModalContent>
          <S.ContentText>
            Ao desativar o rastreio para um contato, ele não terá mais acesso ao rastreio de nenhum dos pedidos que você enviar.
          </S.ContentText>
          <S.ContentText>
            Tem certeza que deseja desabilitar o acompanhamento de pedidos em tempo real para este contato?
          </S.ContentText>
        </S.ModalContent>

        <S.ModalFooter>
          <S.StyledButton
            onClick={onClose}
          >
            Cancelar
          </S.StyledButton>
          <S.StyledButton
            skin="primary"
            onClick={onSubmit}
          >
            Salvar
          </S.StyledButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </Dialog>
  );
};

export default ConfirmationModal;
